import { TableCell, Typography } from "@material-ui/core";
import { ChipBlock } from "componentsNew/elements/ChipBlock";
import {
  DISPATCHER,
  fleetStatusConstants,
  MANAGER,
  outOfServiceReasonConstants,
} from "constants/constants";
import { FleetData } from "types/DaAndFleet";
import { FleetCheckbox } from "./FleetCheckbox";
import { CustomDrawer } from "componentsNew/drawers/CustomDrawer";
import { FleetEditDrawerContent } from "componentsNew/drawers/drawerContent/FleetEditDrawerContent";
import { DateTime } from "luxon";

export const FleetStatusCell = (
  columnId: any,
  cellData: FleetData,
  classes: any,
  station: string | undefined,
  userRole: number,
) => {
  const cellClass = `${classes.tableCell} ${classes.fixedHeight}`;

  switch (columnId) {
    case "checkbox":
      return (
        <TableCell key={`fleet-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <FleetCheckbox data={cellData} disabled={[DISPATCHER, MANAGER].includes(userRole)} />
        </TableCell>
      );
    case "number":
      return (
        <TableCell key={`fleet-cell-${columnId}-${cellData.id}`} className={cellClass}>
          {![DISPATCHER, MANAGER].includes(userRole) ? (
            <CustomDrawer
              customWidth={440}
              buttonType={"custom"}
              drawer_name={`fleet-${cellData.number}-edit-drawer`}
              drawerTitle={`Edit Fleet ${cellData.number}’s Information`}
              customButtonElement={
                <Typography className={classes.editButton}>{cellData.number}</Typography>
              }
            >
              <FleetEditDrawerContent data={cellData} />
            </CustomDrawer>
          ) : (
            <Typography className={classes.editButtonDisabled}>{cellData.number}</Typography>
          )}
        </TableCell>
      );
    case "status":
      const status = cellData.status;
      return (
        <TableCell key={`fleet-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>
            {
              <ChipBlock
                text={fleetStatusConstants.find((data) => data.value === status)?.option}
                theme={status === 1 ? "green" : status === 3 ? "gray" : "yellow"}
              />
            }
          </Typography>
        </TableCell>
      );
    case "fleet_size":
      return (
        <TableCell key={`fleet-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>{cellData.fleet_size.title}</Typography>
        </TableCell>
      );
    case "van_group":
      return (
        <TableCell className={cellClass}>
          <Typography>{cellData.van_group.name}</Typography>
        </TableCell>
      );
    case "ownership":
      return (
        <TableCell className={cellClass}>
          <Typography>{cellData.van_group.fleet_ownership === 1 ? "Rental" : "Owner"}</Typography>
        </TableCell>
      );
    case "status_change_reason":
      return (
        <TableCell key={`fleet-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>
            {cellData.status === 2
              ? outOfServiceReasonConstants.find(
                  (reason) => reason.value === cellData.status_change_reason,
                )?.option
              : ""}
          </Typography>
        </TableCell>
      );
    case "last_edit":
      return (
        <TableCell key={`fleet-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>
            {cellData.last_edit && cellData.last_edited_by
              ? `${cellData.last_edit} by ${cellData.last_edited_by}`
              : "---"}
          </Typography>
        </TableCell>
      );
    case "pick_up_date":
      return (
        <TableCell key={`da-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>{DateTime.fromISO(cellData.pick_up_date).toFormat("dd-MM-yyyy")}</Typography>
        </TableCell>
      );
    case "station":
      return (
        <TableCell key={`fleet-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>{station}</Typography>
        </TableCell>
      );
    default:
      return (
        <TableCell key={`fleet-cell-${columnId}-${cellData.id}`} className={cellClass}>
          <Typography>{cellData ? cellData[columnId as keyof FleetData] : "---"}</Typography>
        </TableCell>
      );
  }
};
